import { render, staticRenderFns } from "./ColumnsSettingsGoodsItems.vue?vue&type=template&id=61da07ca"
import script from "./ColumnsSettingsGoodsItems.vue?vue&type=script&lang=js"
export * from "./ColumnsSettingsGoodsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports